const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
};

export const openWhatsAppSupport = () => {
    openInNewTab("https://wa.me/972559995677");
};